import axios from "axios";
import { OpenAPI } from "@propertelligent/client-api";

export interface TransactionExportRequest {
  path: string;
  queryParams: Record<string, unknown>;
}

const authHeaders = () => {
  const token = typeof OpenAPI.TOKEN === "string" ? OpenAPI.TOKEN : "";
  return {
    Authorization: `Bearer ${token}`,
  };
};

// ASP.NET Core model-binds a List<int> query param from repeated
// `key=value&key=value` pairs, NOT axios's default bracketed
// `key[]=value&key[]=value` array serialization. Using axios's default
// `params` object for FilterEntityIds silently binds to an empty list
// server-side, which trips the "Filter Entity Ids are required..." 400
// validation error even when a valid entity id was sent. Build the query
// string manually (mirroring the generated client's own getQueryString) so
// arrays serialize the way the backend expects.
const buildQueryString = (params: Record<string, unknown>): string => {
  const qs: string[] = [];
  const append = (key: string, value: unknown) => {
    qs.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
  };
  const process = (key: string, value: unknown) => {
    if (value === undefined || value === null) return;
    if (Array.isArray(value)) {
      value.forEach((v) => process(key, v));
    } else if (typeof value === "object") {
      Object.entries(value as Record<string, unknown>).forEach(([k, v]) =>
        process(`${key}[${k}]`, v)
      );
    } else {
      append(key, value);
    }
  };
  Object.entries(params).forEach(([key, value]) => process(key, value));
  return qs.length > 0 ? `?${qs.join("&")}` : "";
};

export const exportTransactionsToExcel = async ({
  path,
  queryParams,
}: TransactionExportRequest): Promise<Blob> => {
  const base = OpenAPI.BASE || "";
  const res = await axios.get(`${base}${path}${buildQueryString(queryParams)}`, {
    headers: authHeaders(),
    responseType: "blob",
  });

  return res.data as Blob;
};

export const downloadBlob = (blob: Blob, fileName: string): void => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
